import { DateTimeUnit } from "abweb/dto/generated/inputargs/DateTimeUnit";
import { RelativeDateSpecifierBase } from "abweb/dto/generated/inputargs/RelativeDateSpecifierBase";
import { RelativeDateStart } from "abweb/dto/generated/inputargs/RelativeDateStart";
import { ClassUtils } from "abweb/utils/ClassUtils";
export class RelativeDateSpecifier extends RelativeDateSpecifierBase {
  static createRelativeDateSpecifier(offset, start, unit) {
    const retVal = new RelativeDateSpecifier();
    retVal.initRelativeDateSpecifier(offset, start, unit);
    return retVal;
  }

  /**
   * Parses the given date specifier relative to the given date. If the given date is null, then uses
   * the current date.
   */
  static parseDateSpecifier(dateOrSpecifier, now = null) {
    if (!dateOrSpecifier) {
      return null;
    } else if (ClassUtils.isInstanceOf(dateOrSpecifier, Date)) {
      return dateOrSpecifier;
    } else {
      return dateOrSpecifier.computeDate(now);
    }
  }
  constructor() {
    super();
    this.initRelativeDateSpecifier(0, RelativeDateStart.Now, DateTimeUnit.Day);
  }
  initFromJson(json, deserializeContext) {
    super.initFromJson(json, deserializeContext);
    if (this.offset == null) {
      this.offset = NaN;
    }
  }
  clone() {
    return RelativeDateSpecifier.createRelativeDateSpecifier(this.offset, this.start, this.unit);
  }

  /**
   * Returns date using date specification relative to {@link now} date.
   * @param fromDate Date is computed relative to this date. If not specified, uses current date.
   */
  computeDate(fromDate = null) {
    if (!fromDate) {
      fromDate = new Date();
    }

    // first get the starting point
    let startDate;
    switch (this.start) {
      case RelativeDateStart.StartOfYear:
        startDate = new Date(fromDate.getFullYear(), 0, 1, 0, 0, 0, 0);
        break;
      case RelativeDateStart.StartOfMonth:
        startDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1, 0, 0, 0, 0);
        break;
      case RelativeDateStart.StartOfWeek:
        startDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate() - fromDate.getDay(), 0, 0, 0, 0);
        break;
      case RelativeDateStart.StartOfDay:
        startDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), 0, 0, 0, 0);
        break;
      case RelativeDateStart.StartOfHour:
        startDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), fromDate.getHours(), 0, 0, 0);
        break;
      case RelativeDateStart.EndOfYear:
        startDate = new Date(fromDate.getFullYear(), 11, 31, 23, 59, 59, 999);
        break;
      case RelativeDateStart.EndOfMonth:
        // get the start of the next month and subtract one millisecond
        startDate = new Date(fromDate.getFullYear(), fromDate.getMonth() + 1, 0, 0, 0, 0, 0);
        startDate.setTime(startDate.getTime() - 1);
        break;
      case RelativeDateStart.EndOfWeek:
        startDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate() + 6 - fromDate.getDay(), 23, 59, 59, 999);
        break;
      case RelativeDateStart.EndOfDay:
        startDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), 23, 59, 59, 999);
        break;
      case RelativeDateStart.EndOfHour:
        startDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), fromDate.getHours(), 59, 59, 999);
        break;
      default:
        startDate = fromDate;
        break;
    }
    let millis;
    switch (this.unit) {
      case DateTimeUnit.Second:
        millis = 1000;
        break;
      case DateTimeUnit.Minute:
        millis = 60 * 1000;
        break;
      case DateTimeUnit.Hour:
        millis = 60 * 60 * 1000;
        break;
      case DateTimeUnit.Day:
        millis = 24 * 60 * 60 * 1000;
        break;
      case DateTimeUnit.Week:
        millis = 7 * 24 * 60 * 60 * 1000;
        break;
      case DateTimeUnit.Month:
        millis = 30 * 24 * 60 * 60 * 1000;
        break;
      case DateTimeUnit.Year:
        millis = 365 * 24 * 60 * 60 * 1000;
        break;
      default:
        millis = 0;
        break;
    }
    return new Date(startDate.valueOf() + millis * this.offset);
  }
}
//# sourceMappingURL=RelativeDateSpecifier.js.map
